export class IntegrationsUrlParamsModel {
	integrationId: string;
	section?: string;
	mapperType?: string;
	isMapper?: boolean;
	organizationIntegrationId?: string;
	parentIntegrationId?: string;
	isExternalIntegration?: boolean;
	customUrl?:string;
	customSaveUrl?:string;
	externalSingleData? :boolean; //when the response is not an Object
	externalSingleDataKey?: string;
	hasDeleteAction?: boolean;

	constructor() {
		this.integrationId = '';
		this.section = null;
		this.mapperType = null;
		this.isMapper = false;
		this.isExternalIntegration = false;
		this.customUrl = '';
		this.customSaveUrl = '';
		this.externalSingleData = false;
		this.externalSingleDataKey = '';
		this.hasDeleteAction= true;
	}
}
